import { Injectable } from '@angular/core';
import { ToastController, Platform } from '@ionic/angular';

import { AuthService } from './auth.service';
import { LogService } from './log.service';

@Injectable({
    providedIn: 'root'
})
export class ToastService
{
    private errorToast = null;
    private warningToast = null;
    private infoToast = null;

    constructor(
        private toastCtrl: ToastController,
        private platform: Platform,
        private auth: AuthService,
        private log: LogService
    )
    {
    }

    async errorNotification(message)
    {
        if (!this.auth.empty(this.errorToast)) {
            this.errorToast.dismiss().then(() => {
                this.errorToast = null;
            }).catch(() => {
                this.errorToast = null;
            }).finally(() => {
                this.showError(message);
            });

            return;
        }

        this.showError(message);
    }

    async showError(message)
    {
        this.log.debug(`errorNotification -> open ${message}`);

        this.errorToast = await this.toastCtrl.create({
            message: message+'<style>.toast-content{overflow:hidden;}</style>',
            position: 'top',
            color: 'danger',
            mode: 'ios',
            duration​: 5000,
            buttons: [
                {
                    side: 'end',
                    icon: 'close-circle-outline',
                    handler: () => {
                        this.errorToast.dismiss();
                    }
                }
            ],
        });

        await this.errorToast.present();
    }

    async warningNotification(message)
    {
        if (!this.auth.empty(this.warningToast)) {
            this.warningToast.dismiss().then(() => {
                this.warningToast = null;
            }).catch(() => {
                this.warningToast = null;
            }).finally(() => {
                this.showWarning(message);
            });

            return;
        }

        this.showWarning(message);
    }

    async showWarning(message)
    {
        this.log.debug(`warningNotification -> open ${message}`);

        this.warningToast = await this.toastCtrl.create({
            message: message+'<style>.toast-content{overflow:hidden;}</style>',
            position: 'top',
            color: 'warning',
            mode: 'ios',
            duration​: 5000,
            buttons: [
                {
                    side: 'end',
                    icon: 'close-circle-outline',
                    handler: () => {
                        this.warningToast.dismiss();
                    }
                }
            ],
        });

        await this.warningToast.present();
    }

    async infoNotification(message)
    {
        if (!this.auth.empty(this.infoToast)) {
            this.infoToast.dismiss().then(() => {
                this.infoToast = null;
            }).catch(() => {
                this.infoToast = null;
            }).finally(() => {
                this.showInfo(message);
            });

            return;
        }

        this.showInfo(message);
    }

    async showInfo(message)
    {
        this.log.debug(`infoNotification -> open ${message}`);

        this.infoToast = await this.toastCtrl.create({
            message: message+'<style>.toast-content{overflow:hidden;}</style>',
            position: 'top',
            color: 'dark',
            mode: 'ios',
            duration​: 3000,
            buttons: [
                {
                    side: 'end',
                    icon: 'close-circle-outline',
                    handler: () => {
                        this.infoToast.dismiss();
                    }
                }
            ],
        });

        await this.infoToast.present();

    }
}
